import React, { Fragment } from 'react'
import { BookNotifications } from './bookNotifcations'
import { ModalConsumer } from "../Login/loginContext";
import ModalRoot from "../Login/loginRoot";

import './bookNotificationsLandingPage.css'

export class BookNotificationsLandingPage extends React.Component {
    componentDidMount() {
        document.getElementById('helpaAndLoginContainer').style.visibility = 'hidden'
        document.getElementById('RightFooterContainer').style.visibility = 'hidden'

        this.showDialog.click()
    }

    onRequestClose = () => {
        this.props.history.goBack()
    }

    render() {
        return (
            <div className="notifications-landing-page">
                <ModalRoot />
                <ModalConsumer>
                {({ showModal }) => (
                    <Fragment>
                        <div ref={x => this.showDialog = x} onClick={() => showModal(BookNotifications, {onClose: this.onRequestClose})}></div>
                    </Fragment>
                )}
                </ModalConsumer>
            </div>
        )
    }
}
